import { VALIDATE_VIDEO_CODE_REQUEST, VALIDATE_VIDEO_CODE_SUCCESS, VALIDATE_VIDEO_CODE_FAILURE } from "../Types/types";

const initialState = {
  validating: false,
  connectionDetails: null,
};

export default function videoInterviewReducer(state = initialState, action) {
    switch (action.type) {
        case VALIDATE_VIDEO_CODE_REQUEST:
            return { ...state, validating: true };
        case VALIDATE_VIDEO_CODE_SUCCESS:
            return { ...state, validating: false, connectionDetails: action.payload };
        case VALIDATE_VIDEO_CODE_FAILURE:
            return { ...state, validating: false };
    default:
        return state;
    }
}